export const RECEIVE_DELETE_PASSENGERS = 'RECEIVE_DELETE_PASSENGERS'

export default (passengerIds: string[]) => ({
  type: RECEIVE_DELETE_PASSENGERS,
  passengerIds,
})
